import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { STATIC_FRONTEND_MODE } from "@/lib/backend";

const SiteKnowledgeContext = createContext(null);

const EMPTY = {
  pages: [],
  faqs: [],
  service_qa: [],
  geo_services: [],
  geo_sources: [],
  completeness: null,
};

export function SiteKnowledgeProvider({ children }) {
  const [knowledge, setKnowledge] = useState(EMPTY);

  const refresh = useCallback(async () => {
    if (STATIC_FRONTEND_MODE) return;
    try {
      const res = await api.get("/public/site-knowledge", { timeout: 8000 });
      setKnowledge({ ...EMPTY, ...(res.data || {}) });
    } catch {
      /* keep last */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteKnowledgeContext.Provider value={{ knowledge, refresh }}>
      {children}
    </SiteKnowledgeContext.Provider>
  );
}

export function useSiteKnowledge() {
  return useContext(SiteKnowledgeContext) || { knowledge: EMPTY, refresh: () => {} };
}
